import React, { useRef, useState } from 'react';
import './TemplatesListByFolder.css';
import TemplateList from '@src/web-stories-wp/story-editor/src/components/library/panes/pageTemplates/templateList';
import styled from 'styled-components';
import { virtualPaneContainer } from '@src/web-stories-wp/story-editor/src/components/library/panes/shared/virtualizedPanelGrid';
import PropTypes from 'prop-types';
import { useStudioContext } from '@src/hooks/studioContext';
import { getTemplateCardSize } from './getTemplateCardSize';

const PageTemplatesParentContainer = styled.div`
  ${virtualPaneContainer};
  margin-top: 12px;
  height: auto;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: scroll;
`;

const TemplatesListByFolder = ({
  templates,
  loadTemplates,
  canReorderTemplates,
  onReorderTemplate,
  shouldDisplayNoTemplateFoundMessage,
  renderTemplateActions,
}) => {
  const listContainerRef = useRef();
  const [listContainer, setListContainer] = useState(null);
  listContainerRef.current = listContainer;
  const { assetType, contentBankAssetType, cardsAssetType } =
    useStudioContext();
  const finalAssetType = cardsAssetType || contentBankAssetType || assetType;
  const pageSize = getTemplateCardSize(finalAssetType);

  return (
    <>
      {shouldDisplayNoTemplateFoundMessage && (
        <div className="templatesListByFolder__noResults">No results found</div>
      )}

      <PageTemplatesParentContainer ref={setListContainer}>
        {listContainer && (
          <TemplateList
            pageSize={pageSize}
            parentRef={listContainerRef}
            pages={templates}
            fetchTemplates={loadTemplates}
            canReorderTemplates={canReorderTemplates}
            onReorderTemplate={onReorderTemplate}
            renderTemplateActions={renderTemplateActions}
          />
        )}
      </PageTemplatesParentContainer>
    </>
  );
};

TemplatesListByFolder.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadTemplates: PropTypes.func.isRequired,
  canReorderTemplates: PropTypes.bool,
  onReorderTemplate: PropTypes.func,
  shouldDisplayNoTemplateFoundMessage: PropTypes.bool.isRequired,
  renderTemplateActions: PropTypes.func,
};

export default TemplatesListByFolder;
